var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCapacete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#02404F;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capacete",
    transform: "translate(-1.18 -8.495)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_475",
    className: "st0",
    d: "M8.2,32.5c-1.9,0-3.7-0.6-5.2-1.6c-0.1-0.1-0.2-0.2-0.3-0.4c-0.9-2.1-1.4-4.3-1.5-6.6 c-0.1-2,0.3-4,1.1-5.9c1.1-2.3,2.9-4.1,5-5.4c1.4-0.9,3-1.5,4.6-2c1.5-0.4,3-0.6,4.5-0.6c1.6,0,3.2,0.2,4.7,0.7 c1.5,0.4,2.8,1.1,4.1,2c1.2,0.8,2.3,1.8,3.3,2.9c0.9,1.1,1.6,2.4,2.1,3.7l0,0.1c0.3,0.7,0.8,2,0.1,3.2c-0.3,0.5-0.7,0.9-1.2,1.1 c-0.6,0.3-1.3,0.5-2,0.6h0c-1.5,0.2-2.9,0.3-4.4,0.3c-0.1,0.3-0.2,0.5-0.3,0.8c-0.6,1.1-1.7,1.9-2.9,2.1c-0.4,0.1-0.9,0.1-1.4,0.1 c-0.8,0-1.6-0.2-2.2-0.8c-0.5-0.5-0.8-1.1-1-1.7c-0.1-0.1-0.3-0.2-0.5-0.2c-0.5,0-0.9,0.2-1.2,0.5c-0.2,0.2-0.3,0.5-0.3,0.7 c0,0.4,0.1,0.9,0.2,1.3c0.2,0.7,0.2,1.5,0.1,2.2c-0.2,0.8-0.9,1.4-2,2C10.6,32.3,9.4,32.5,8.2,32.5z M4.2,29.5 c1.2,0.7,2.5,1.1,3.9,1.1c0.9,0,1.8-0.2,2.7-0.6c0.6-0.3,1-0.6,1-0.8c0-0.4,0-0.8-0.1-1.2c-0.1-0.5-0.2-1-0.3-1.5 c-0.1-0.8,0.2-1.6,0.7-2.1c0.7-0.7,1.6-1.1,2.6-1.1c0.9-0.1,1.8,0.5,2.2,1.3c0.5,1.1,0.6,1.3,1.5,1.3c0.4,0,0.7,0,1-0.1 c0.7-0.1,1.3-0.5,1.6-1.1c0.2-0.3,0.3-0.6,0.3-0.9c0-0.5,0.5-0.9,0.9-0.9c0.2,0,0.3,0,0.5,0c1.5,0,2.9-0.1,4.4-0.3 c1-0.1,1.7-0.4,1.9-0.8c0.3-0.4,0-1.1-0.2-1.6l0-0.1c-1.8-4.8-6.9-8.1-12.5-8.1c-2.9,0-5.7,0.8-8.2,2.4c-3.6,2.1-5.4,5.4-5.3,9.6 C3.1,25.8,3.5,27.7,4.2,29.5L4.2,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_476",
    className: "st0",
    d: "M20,34.2c0,0-0.1,0-0.1,0c-3.7-0.6-7.8-3.3-7.9-3.4c-0.4-0.3-0.5-0.9-0.2-1.3 c0.3-0.4,0.9-0.5,1.3-0.2l0,0c0,0,3.9,2.6,7.2,3.1c0.5,0.1,0.9,0.5,0.8,1.1C20.9,33.9,20.5,34.2,20,34.2L20,34.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_480",
    className: "st0",
    d: "M20.8,36.9c-0.4,0-0.8-0.3-0.9-0.7c-0.9-3.1-1.4-6.3-1.5-9.5c0-0.5,0.4-0.9,0.9-0.9h0 c0.5,0,0.9,0.4,0.9,0.9l0,0c0.1,3,0.6,6,1.5,8.9c0.1,0.5-0.1,1-0.6,1.1C20.9,36.9,20.9,36.9,20.8,36.9L20.8,36.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_481",
    className: "st0",
    d: "M20,33.8c-0.5,0-0.9-0.4-0.9-0.9c0-0.2,0-0.3,0.1-0.5c1.5-2.5,2.3-8.7,2.3-8.8 c0.1-0.5,0.5-0.9,1-0.8c0.5,0.1,0.9,0.5,0.8,1l0,0c0,0.3-0.9,6.7-2.5,9.5C20.7,33.7,20.4,33.8,20,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Elipse_142",
    className: "st0",
    d: "M6.4,16.7c0.9,0,1.7,0.8,1.7,1.7S7.4,20,6.4,20s-1.7-0.8-1.7-1.7c0,0,0,0,0,0 C4.8,17.4,5.5,16.7,6.4,16.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapacete);
export default __webpack_public_path__ + "static/media/Capacete.3f9725e37a980dccdf8775531f8ed3fc.svg";
export { ForwardRef as ReactComponent };